// extracted by mini-css-extract-plugin
export default {"wrapper":"UserCards_wrapper__Su2Vr"};